module.exports = __webpack_public_path__ + "media/images/categoryIcons/race_relations_icon-d970d715b52880bf4d02beae861a9d28.svg";